import React from "react";
import { Div, Select } from "../../../Components/Kit";
import { useForm } from "react-hook-form";

const AdditionalInformation: React.FC = () => {
  const { control } = useForm();
  return (
    <Div className="w-full max-w-[1200px] mx-auto xs:px-[20px] py-[47px]">
      <Select control={control} name="test" options={[]} />
    </Div>
  );
};

export default AdditionalInformation;